import { Fragment } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { Card, CardBody, Col, Container, Row } from "reactstrap";

import { Breadcrumbs } from "AbstractElements";
import TheForm from "Components/Common/Component/form/TheForm";
import { useCrudApi } from "hook/useCrudApi";
import { useResourceNavigate } from "hook/useResourceNavigate";
import { TheoDoiViPham } from "models/theo-doi-vi-pham";
import { useFormFields, parent, title } from "./constant";

export const CreatePage = () => {
  const { useCreate } = useCrudApi<TheoDoiViPham>("TheoDoiViPham");
  const { toList } = useResourceNavigate("ho-so-don-vi");

  const { mutate: createUser } = useCreate({
    onSuccess: () => {
      toList();
      toast.success("Thêm mới thành công");
    },
    onError: (error) => {
      toast.error("Có lỗi");
    },
  });

  const useFormReturn = useForm();
  const { handleSubmit } = useFormReturn;

  const formFields = useFormFields(useFormReturn);

  const onSubmit = (values) => {
    createUser({ ...values });
  };

  return (
    <Fragment>
      <Breadcrumbs title={title} parent={parent} mainTitle={title} />
      <Container fluid={true}>
        <Row>
          <Col sm="12">
            <Card>
              <CardBody>
                <TheForm
                  {...useFormReturn}
                  items={formFields as any}
                  onSubmit={handleSubmit(onSubmit)}
                  onCancel={toList}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};
